import { useQuery } from '@tanstack/react-query';

import { ConditionView, ContentField, Typography } from '@/shared/ui';

import { queryKeys } from '@/api/queryKeys';
import { Weapon_v2 } from '@/api/types';

import api from '@/api';

import { SkeletonWeapons, WeaponFilters, WeaponList } from './children';
import { useWeaponFilter } from './hooks/useWeaponFilter';
import { messages } from './uk.l10n';

import './WeaponRegistered.scss';

export const WeaponRegistered: React.FC = () => {
  const { isLoading: isListLoading, data: weapons } = useQuery({
    queryKey: queryKeys.weapons.list(),
    queryFn: () => api.getWeaponsData_v2().then((r) => r.data),
  });

  const {
    filterStatusOptions,
    filterTypeOptions,
    filteredWeapons,
    selectedStatus,
    selectedType,
    setSelectedStatus,
    setSelectedType,
    resetFilters,
  } = useWeaponFilter((weapons?.weapons as Weapon_v2[]) ?? []);

  return (
    <div className="weapon-registered">
      <div className="container">
        <Typography className="weapon-registered__title" variant="H1">
          Моя зброя
        </Typography>

        <ConditionView
          if={!weapons && !isListLoading}
          else={
            <section className="weapon-registered__content">
              <ConditionView if={!isListLoading} else={<SkeletonWeapons />}>
                <WeaponFilters
                  filterStatusOptions={filterStatusOptions}
                  filterTypeOptions={filterTypeOptions}
                  selectedStatus={selectedStatus}
                  setSelectedStatus={setSelectedStatus}
                  selectedType={selectedType}
                  setSelectedType={setSelectedType}
                  resetFilters={resetFilters}
                />
                <WeaponList
                  weapons={filteredWeapons}
                  informers={weapons?.informers ?? []}
                  resetFilters={resetFilters}
                />
              </ConditionView>
            </section>
          }
        >
          <section className="weapon-registered__error">
            <ContentField
              icon="no_result"
              content={
                <Typography color="graphite" textCenter>
                  {messages.NOT_FOUND}
                </Typography>
              }
            />
          </section>
        </ConditionView>
      </div>
    </div>
  );
};
